import { complianceFrameworksModule } from './modules/compliance-frameworks';
import { technicalDocumentationModule } from './modules/technical-documentation';
import { auditPreparationModule } from './modules/audit-preparation';
import { knowledgeManagementModule } from './modules/knowledge-management';

export const complianceDocumentationCourse = {
  id: 'enterprise-compliance-documentation',
  title: 'Enterprise Compliance & Technical Documentation',
  description: 'Regulatory compliance, technical documentation, and audit preparation for enterprise software',
  level: 'intermediate',
  totalDuration: '10 hours',
  image: '/api/placeholder/400/300',
  prerequisites: ['Software development experience'],
  learningOutcomes: [
    'Create comprehensive technical documentation and specifications',
    'Ensure regulatory compliance in software development',
    'Prepare for security audits and compliance reviews',
    'Maintain documentation standards and knowledge management'
  ],
  modules: [
    { ...complianceFrameworksModule, order: 1, estimatedTime: 75 },
    { ...technicalDocumentationModule, order: 2, estimatedTime: 60 },
    { ...auditPreparationModule, order: 3, estimatedTime: 45 },
    { ...knowledgeManagementModule, order: 4, estimatedTime: 50 }
  ]
};